import React, { useState, useEffect } from 'react';
import FormRegister from './FormRegister';
import * as RegistrationService from '../../services/RegistrationService';
import VerifyCode from './VerifyCode';
import VerifyCodeModal from './VerifyCodeModal';

export default function NewUserRegistration() {
  const [userDetails, setUserDetails] = useState(null);
  const [showVerfiyPhoneModal, setShowVerfiyPhoneModal] = useState(false);
  const [isPhoneNumberExists, setIsPhoneNumberExists] = useState(false);
  const [codeValidationStatus, setCodeValidationStatus] = useState(false);
  const [resetCode, setResetCode] = useState(false);
  const [countriesData, setCountriesData] = useState(null);

  const updateStoreStateHandler = (params) => {
    sendCodeToPhone(params.mobileNumber);
    setUserDetails(params);
  };

  const sendCodeToPhone = async (phoneNumber) => {
    const checkPhoneRequest = {
      phone_number: phoneNumber,
      digits_phone: `91${phoneNumber}`,
      type: 'register'
    };

    const checkPhoneResponse = await RegistrationService.checkPhone(
      checkPhoneRequest
    );
    if (checkPhoneResponse.error) {
      setIsPhoneNumberExists(true);
    } else {
      if (checkPhoneResponse.otpSent) {
        setShowVerfiyPhoneModal(true);
        setIsPhoneNumberExists(false);
      }
    }
  };

  const checkCodeHandler = async (otp) => {
    const verifyPhoneRequest = {
      digits_phone: userDetails.mobileNumber,
      type: 'register',
      otp: otp
    };
    const verifyPhoneResponse = await RegistrationService.verifyPhoneNumberAndOTPForLogin(
      verifyPhoneRequest
    );
    if (verifyPhoneResponse.error) {
      setCodeValidationStatus(true);
      setIsPhoneNumberExists(false);
      setResetCode(false);
    } else {
      registerUser();
    }
  };

  const registerUser = async () => {
    const newUser = { ...userDetails };
    const response = await RegistrationService.register(newUser);
    if (!response.error) {
      setShowVerfiyPhoneModal(false);
      window.location = '/dashboard';
    } else {
      setIsPhoneNumberExists(true);
      setCodeValidationStatus(false);
    }
  };

  const fetchCountries = async (param) => {
    const response = await RegistrationService.getCountries(param);
    if (!response.error) {
      setCountriesData(response);
    }
  }

  useEffect(() => {
    fetchCountries("IN");
  }, [])

  return (
    <>
      {showVerfiyPhoneModal && (
        <VerifyCodeModal openModal={showVerfiyPhoneModal}>
          <div className="text-center py-3">
            <h3>{'Enter verification code'}</h3>
          </div>
          <VerifyCode
            maxDigits={6}
            checkCode={checkCodeHandler}
            codeValidationFailed={codeValidationStatus}
            resetCode={resetCode}
          />
          {isPhoneNumberExists && (
            <div className="text-danger text-center py-3">
              {'Phone number has been registered already'}
            </div>
          )}
          {/* <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-link"
              onClick={resendCodeHandler}
            >
              <h5> {'Resend verification code?'}</h5>
            </button>
          </div> */}
        </VerifyCodeModal>
      )}
      <FormRegister updateStoreStateHandler={updateStoreStateHandler} countriesData={countriesData} />

    </>
  );
}
